import axios from 'axios'
import { ACATS_AUDIT_TRAIL_API, WITH_CREDENTIALS_CONFIG } from './constants'

export const getAuditTrail = (processingCaseId: number) => {
  return axios.get(
    ACATS_AUDIT_TRAIL_API(processingCaseId),
    WITH_CREDENTIALS_CONFIG
  )
}
